import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { Role, SubRole } from "../../../../users/models/users.entity";

interface GoFurtherLink {
  image: string;
  title: string;
  subTitle: string;
  description: string;
  link: string;
  isExternalLink: boolean;
  queryParams?: any;
}

interface ImagesLinks {
  "tree-in-head": string;
  coach: string;
  train: string;
}

@Component({
  selector: 'app-welcome-links',
  templateUrl: './welcome-links.component.html'
})
export class WelcomeLinksComponent implements OnInit {
  @Input() role!: SubRole;

  @Input() images$!: Observable<ImagesLinks>;


  links!: GoFurtherLink[];

  ngOnInit() {
    if (this.images$) {
      this.images$.subscribe(images => {
        this.links = this.goFurtherLinks(this.role, images);
      });
    }
  }

  goFurtherLinks(role: SubRole, images: ImagesLinks): GoFurtherLink[] {
    return Role.Admin === role ? [] : [
      {
        image: 'assets/images/tree-in-head.png',
        title: "home.welcomeLinks.serviceTitle",
        subTitle: "home.welcomeLinks.serviceSub",
        description: "home.welcomeLinks.serviceDesc",
        link: ['home', 'welcome'].join("/"),
        isExternalLink: false,
        queryParams: { role }
      },
      {
        image: 'assets/images/coach.png',
        title: "home.welcomeLinks.coachesTitle",
        subTitle: "home.welcomeLinks.coachesSub",
        description: "home.welcomeLinks.coachesDesc",
        link: '/home/sherpas',
        isExternalLink: false
      },
      {
        image: 'assets/images/train.png',
        title: "home.welcomeLinks.trainsTitle",
        subTitle: "home.welcomeLinks.trainsSub",
        description: "home.welcomeLinks.trainsDesc",
        link: '/home/talkers',
        isExternalLink: false
      }
    ];
  }
}